import { Component, Injectable, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
    moduleId: module.id,
    selector: "settings",
    templateUrl: './settings.component.html',
    styleUrls: ['../../../../../css/fuck.css', './settings.css'],
    providers: []
})

@Injectable()
export class SettingsComponent implements OnInit {
    public current_tab: string = 'user';
    public user: any;
    
    constructor(private route: ActivatedRoute) {
        this.user = JSON.parse(localStorage.getItem('User'));
    }

    ngOnInit() {
        if(this.route.snapshot.queryParamMap.get('force')) {
            this.current_tab = this.route.snapshot.queryParamMap.get('force');
        }
        console.log(this.current_tab);
    }


    tab(name) {
        this.current_tab = name;
    }

}



// WEBPACK FOOTER //
// G:/3csoft/client-final/src/app/pages/admin/icontact/setting/settings.component.ts